const Onekey = ({ ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M24 12C24 20.2843 20.2843 24 12 24C3.71573 24 0 20.2843 0 12C0 3.71573 3.71573 0 12 0C20.2843 0 24 3.71573 24 12Z'
      fill='#44D62C'
    />
    <path d='M13.0842 5.0885H9.74582L9.16016 6.85933H11.0143V10.5897H13.0842V5.0885Z' fill='black' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.8074 15.1043C15.8074 17.207 14.1027 18.9115 12 18.9115C9.89737 18.9115 8.19287 17.207 8.19287 15.1043C8.19287 13.0017 9.89737 11.2972 12 11.2972C14.1027 11.2972 15.8074 13.0017 15.8074 15.1043ZM14.0789 15.1043C14.0789 16.2525 13.1482 17.1832 12 17.1832C10.852 17.1832 9.92137 16.2525 9.92137 15.1043C9.92137 13.9563 10.852 13.0255 12 13.0255C13.1482 13.0255 14.0789 13.9563 14.0789 15.1043Z'
      fill='black'
    />
  </svg>
);

export default Onekey;
